/* eslint-disable @next/next/no-img-element */

import { FC, ImgHTMLAttributes, useState } from 'react';

type Props = ImgHTMLAttributes<any>;

const ImageNotFallback: FC<Props> = ({ ...props }) => {
    return (
        <img className='h-auto w-full' {...props} alt={props.alt ?? '_img'} />
    );
};

export default ImageNotFallback;
